import { PAYMENT_TYPE } from '../../../../main/payment/constants';

export const PAYMENT_TYPE_LABEL = {
  [PAYMENT_TYPE.cash]: 'Cash',
  [PAYMENT_TYPE.card]: 'Credit card',
  [PAYMENT_TYPE.giftCard]: 'Gift Card',
  [PAYMENT_TYPE.reader]: 'Card reader',
  [PAYMENT_TYPE.readerless]: '3rd party POS',
};

export const ASSIGN_PAYMENTS = 'payment/ASSIGN_PAYMENTS';
export const REMOVE_PAYMENT = 'payment/REMOVE_PAYMENT';
